export const MILLISECOND = 1
export const SECOND = MILLISECOND * 1000
export const MINUTE = SECOND * 60
export const HOUR = MINUTE * 60
export const DAY = HOUR * 24
